const menu = document.querySelector('nav');
const mobileMenu = document.getElementById('menu-mobile');
const allMainMenu = document.getElementsByClassName('nav-menu-item desktop');
const mainMenu = [];
let subMenu = [];

// if not null, and the user clicks outside this element, then close the active menu
let activeMenu = null;

let currentFocus;
let nextFocus;

let horPosition = -1;
let vertPosition = -1;

// checking if the submenu is opened or not
let subMenuOpened = false;

const opts = {
    bubbles: true,
};

// dynamic screen width
let screenWidth;

function isElementInsideMenu(el) {
    let node = el;

    while (node) {
        if (
            node === mobileMenu ||
            (node.nodeName === 'BUTTON' && node.classList.contains('nav-menu-item'))
        ) {
            return true;
        }

        node = node.parentNode;
    }

    return false;
}

document.addEventListener('click', (evt) => {
    const controls = activeMenu && activeMenu.getAttribute('data-nav-list');

    if (!activeMenu || ['mini-context-selector', 'menu-mobile'].indexOf(controls) !== -1) {
        // no menu opened, or the mobile menu is open
        vertPosition = -1;
        return;
    }

    if (!isElementInsideMenu(evt.target)) {
        closeActiveMenu();
        vertPosition = -1;
    }

    getAllMainMenus();
    currentFocus = evt.target;
    vertPosition = -1;
});

// Calling node.dispatchEvent(eventMenuOpen/Close)
//   - (handleMenuOpen)    Toggles aria-expanded on the nav menu item
//   - (handleSubmenuOpen) Toggles aria-expanded on the ul[role=menu] submenu
//   - (handleSubmenuOpen) Reposition ul[role=menu] submenu
//   - (handleSubmenuOpen) Toggles aria-expanded on the footer#menu-mobile

const eventMenuOpen = new CustomEvent('menu.open', opts);
const eventMenuClose = new CustomEvent('menu.close', opts);

function handleMenuOpen(e) {
    const node = e.target;
    node.setAttribute('aria-expanded', true);
    node.setAttribute('data-menu-expanded', true);
}

function handleSubmenuOpen(e, optional) {
    const menuItem = e?.target || optional;
    const haspopup = menuItem.hasAttribute('aria-haspopup');
    const id = menuItem.getAttribute('data-nav-list');

    // target may not necessarily be a submenu
    const subMenuList = document.getElementById(id);

    if (!menuItem || (!haspopup && subMenuList !== mobileMenu)) return;

    if (!id)
        return console.warn(
            'Unable to expand submenu [element %s is missing property data-nav-list]',
            menuItem.id,
        );

    if (!subMenuList)
        return console.warn('Unable to expand submenu %s [target menu does not exist]', id);

    expandItemFor(subMenuList, menuItem);

    if (subMenuList !== mobileMenu && isWithin(subMenuList, mobileMenu)) {
        expandItemFor(mobileMenu, menuItem);
        const targetRect = menuItem.getBoundingClientRect();
        const nodeRect = subMenuList.getBoundingClientRect();
        subMenuList.style.left = `${targetRect.left + nodeRect.width > window.innerWidth ? targetRect.right - nodeRect.width : targetRect.left}px`;
        subMenuList.focus();
    }

    if (subMenuList === mobileMenu) {
        document.body.classList.add('mobile-menu-visible');
    }

    activeMenu = menuItem;
}

function handleMenuClose(e) {
    const menuItem = e.target;
    revertExpand(menuItem);
    menuItem.setAttribute('aria-expanded', false);
    menuItem.setAttribute('data-menu-expanded', false);
    closeActiveMenu(e);
    handleSubmenuClose(e);
    activeMenu = null;
}

function handleSubmenuClose(e) {
    const menuItem = e.target;
    revertExpand(menuItem);
    document.body.classList.remove('mobile-menu-visible');
}

document.addEventListener('menu.open', handleMenuOpen);
document.addEventListener('menu.open', handleSubmenuOpen);
document.addEventListener('menu.close', handleMenuClose);
document.addEventListener('menu.close', handleSubmenuClose);

function handleMenuItemClicked(evt) {
    const menuItem = this;
    const targetId = menuItem.getAttribute('data-nav-list');
    const currentOpenMenu = menu.querySelector('.nav-menu-item[aria-expanded=true]');

    if (currentOpenMenu) currentOpenMenu.dispatchEvent(eventMenuClose);

    if (!targetId && menuItem.hasAttribute('href')) {
        return;
    }

    if (menuItem !== currentOpenMenu) {
        // don't reopen the menu if we just closed it
        menuItem.dispatchEvent(eventMenuOpen);
    }

    // don't jump to URL
    evt.preventDefault();
}

function closeActiveMenu() {
    const currentOpenMenu = menu.querySelector('.nav-menu-item[aria-expanded=true]');

    if (currentOpenMenu) currentOpenMenu.dispatchEvent(eventMenuClose);
}

const menuItems = document.querySelectorAll('nav .nav-menu-item[data-nav-list]');

Array.from(menuItems).forEach((menuItem) => {
    menuItem.addEventListener('click', handleMenuItemClicked);
});

window.addEventListener('resize', closeActiveMenu);

function isWithin(el, ancestor) {
    // some random number, strip the 0. from the start
    if (!el.id) el.id = `${Math.random()}`.substr(2);
    return !!ancestor.querySelector(`#${el.id}`);
}

function expandItemFor(expanded, instigator) {
    expanded.setAttribute('aria-expanded', true);
    expanded.setAttribute('data-menu-expanded', true);

    const dataExpanded = instigator.getAttribute('data-expanded') || '';
    instigator.setAttribute('data-expanded', `${dataExpanded} ${expanded.id}`);
}

function revertExpand(instigator) {
    const expandeds = (instigator.getAttribute('data-expanded') || '').split(' ');

    expandeds.forEach((expanded) => {
        // ignore blanks
        if (!expanded) return;
        expanded = document.getElementById(expanded);

        if (!expanded) {
            console.warn('Unable to revert expanded state [element %s does not exist]', expanded);
            return;
        }

        const state = expanded.getAttribute('aria-expanded');

        if (state === 'true') {
            expanded.setAttribute('aria-expanded', false);
            expanded.setAttribute('data-menu-expanded', false);
        } else if (state === 'false') {
            expanded.getAttribute('aria-expanded', true);
            expanded.getAttribute('data-menu-expanded', true);
        } else {
            console.warn(
                'Unable to revert expanded state [element %s does not have aria-expanded set]',
                expanded,
            );
        }
    });

    instigator.removeAttribute('data-expanded');
}

const logoDiv = document.querySelector('nav#menu #logo');

if (logoDiv) {
    logoDiv.addEventListener('click', (evt) => {
        evt.preventDefault();

        if (window.location.pathname.includes('/past-employees')) {
            window.location.reload(true);
        } else {
            window.location = document.head.querySelector('base').getAttribute('href');
        }
    });
}

window.addEventListener('resize', checkSize);
window.addEventListener('resize', mobileView);

function reset() {
    document.querySelectorAll('#menu-mobile nav').forEach((submenu) => {
        if (submenu.classList.contains('open')) {
            submenu.classList.remove('open');
            submenu.style.overflow = 'hidden';
            submenu.querySelectorAll('li').forEach((listElement) => {
                if (listElement.classList.contains('dropdown-divider')) {
                    listElement.classList.add('d-none');
                }
                setTimeout(() => {
                    listElement.style.maxHeight = '0px';
                }, 10);
            });
        }
    });
}

function mobileView() {
    document.querySelectorAll('#menu-mobile nav > h2').forEach((subHeader) => {
        subHeader.addEventListener('click', (_e) => {
            const parent = subHeader.parentElement;
            if (!parent.classList.contains('open')) {
                parent.classList.add('open');
                parent.style.overflow = '';

                parent.querySelectorAll('li').forEach((listElement) => {
                    if (listElement.classList.contains('dropdown-divider')) {
                        listElement.classList.remove('d-none');
                    }
                    setTimeout(() => {
                        listElement.style.maxHeight = '40px';
                    }, 10);
                });
            } else {
                parent.classList.remove('open');
                parent.style.overflow = 'hidden';
                parent.querySelectorAll('li').forEach((listElement) => {
                    if (listElement.classList.contains('dropdown-divider')) {
                        listElement.classList.add('d-none');
                    }
                    setTimeout(() => {
                        listElement.style.maxHeight = '0px';
                    }, 10);
                });
            }
        });
    });
}

function checkSize() {
    reset();
    screenWidth = window.innerWidth;
    if (screenWidth <= 767) {
        document.querySelectorAll('#menu-mobile nav').forEach((submenu) => {
            submenu.style.overflow = 'hidden';
            submenu.querySelectorAll('li').forEach((listElement) => {
                if (listElement.classList.contains('dropdown-divider')) {
                    listElement.classList.add('d-none');
                }
                listElement.style.maxHeight = '0px';
            });
        });
    } else if (screenWidth >= 768) {
        document.querySelectorAll('#menu-mobile nav').forEach((submenu) => {
            submenu.style.overflow = '';
            submenu.querySelectorAll('li').forEach((listElement) => {
                if (listElement.classList.contains('dropdown-divider')) {
                    listElement.classList.remove('d-none');
                }
                listElement.style.maxHeight = '40px';
            });
        });
    }
    mobileView();
}

document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('aurion-app-reload', () => {
        document.location.reload(true);
    });

    document.querySelector('.mobile-menu-close').addEventListener('click', (evt) => {
        handleMenuClose(evt);
    });

    // Clear navActiveParent when logging out
    document.getElementById('sign-out-menu-link')?.addEventListener('click', (_e) => {
        sessionStorage.removeItem('navActiveParent');
        sessionStorage.removeItem('navHistory');
    });

    checkSize();
    try {
        setActiveParent();
    } catch (_e) {
        // Just in case there's an error :)
    }
});

function setActiveParent() {
    const currentPath = window.location.href;

    // Add event listeners to sub menu items
    const subMenuItems = document.querySelectorAll('#menu-mobile li');
    subMenuItems.forEach((item) => {
        item.addEventListener('click', () => {
            sessionStorage.setItem('navActiveParent', `[data-nav-list="${item.parentElement.id}"]`);
        });
    });

    // Add event listeners to parent menu items
    const parMenuItems = document.querySelectorAll('.main-menus a');
    parMenuItems.forEach((item) => {
        item.addEventListener('click', () => {
            sessionStorage.setItem('navActiveParent', `#${item.id}`);
        });
    });

    let parentId = sessionStorage.getItem('navActiveParent');

    // On login, or after settings menu look for current active page.
    if (!parentId) {
        // First search parent links for match
        parMenuItems.forEach((link) => {
            if (currentPath.endsWith(link.getAttribute('href'))) {
                parentId = `#${link.id}`;
                sessionStorage.setItem('navActiveParent', parentId);
            }
        });

        // Next search for elements in the sublist
        subMenuItems.forEach((listItem) => {
            const link = listItem.querySelector('a');
            if (currentPath.includes(link.getAttribute('href'))) {
                const listId = link.closest('ul')?.id;
                parentId = `[data-nav-list="${listId}"]`;
                sessionStorage.setItem('navActiveParent', parentId);
            }
        });
    }

    if (parentId !== '#') {
        document.querySelector(parentId)?.classList.add('current-menu');
    }
    document.querySelectorAll('#menu-settings a').forEach((menuItem) => {
        menuItem.addEventListener('click', (_e) => sessionStorage.removeItem('navActiveParent'));
    });
}

function getAllMainMenus() {
    if (mainMenu.length > 0) return;

    [...allMainMenu].forEach((element) => {
        mainMenu.push(element.getAttribute('data-nav-list'));
    });
}

function getCurrentSubMenus() {
    const subMenuItems = document.querySelector('ul[data-menu-expanded=true]');

    if (subMenu) {
        subMenu = subMenuItems.querySelectorAll('.d-flex');
        return subMenu;
    }
}

function hasPopup(menuitem) {
    return menuitem.getAttribute('aria-haspopup') === 'true';
}

function goToMainMenuPosition(focus, subMenuOpen, position) {
    if (focus.hasAttribute('data-menu-expanded') && !subMenuOpen) {
        horPosition = position;
        allMainMenu[horPosition].focus();
    }
}

function goToSubMenuPosition(position) {
    vertPosition = position;
    subMenu[vertPosition].focus();
}

function goToPosition(position, focus, subMenuOpen) {
    if (focus.hasAttribute('href') && focus.getAttribute('role') !== 'menuitem') {
        goToSubMenuPosition(position);
    } else {
        goToMainMenuPosition(focus, subMenuOpen, position);
    }
}

function expandAccessibility(focus) {
    const id = focus.getAttribute('data-nav-list');
    if (id) {
        expandItemFor(focus, document.getElementById(id));
    }
}

document.addEventListener('focusin', (evt) => {
    evt.target.setAttribute('tabindex', 0);
    if (evt.target.getAttribute('role') === 'submenu') {
        const id = evt.target.parentNode.parentNode.getAttribute('id');
        document.querySelector(`button[data-nav-list='${id}']`).setAttribute('tabindex', 0);
    } else if (evt.target.getAttribute('class') === 'submenu-list') {
        const id = evt.target.getAttribute('id');
        document.querySelector(`button[data-nav-list='${id}']`).setAttribute('tabindex', 0);
    }
});

document.addEventListener('keydown', (evt) => {
    currentFocus = evt.target;
    let flag = false;
    const keys = evt.code;

    if (
        document.activeElement.hasAttribute('data-menu-expanded') ||
        document.activeElement.getAttribute('role') === 'submenu' ||
        document.activeElement.getAttribute('role') === 'menu' ||
        document.activeElement.getAttribute('role') === 'menuitem'
    ) {
        if (
            currentFocus.getAttribute('data-menu-expanded') === 'true' ||
            currentFocus.parentNode.parentNode.getAttribute('data-menu-expanded')
        ) {
            subMenuOpened = true;
        } else {
            subMenuOpened = false;
        }
        switch (keys) {
            case 'Tab':
                if (allMainMenu[horPosition]) {
                    allMainMenu[horPosition].focus();
                }
                closeActiveMenu();

                if (currentFocus.classList.contains('nav-menu-item')) {
                    currentFocus.setAttribute('tabindex', 0);
                } else if (currentFocus.getAttribute('role') === 'submenu') {
                    const id = currentFocus.parentNode.parentNode.getAttribute('id');
                    const subAttr = document.querySelector(`button[data-nav-list='${id}']`);
                    subAttr.setAttribute('tabindex', 0);
                }

                break;
            case 'Enter':
            case 'Space':
            case ' ':
                if (currentFocus.hasAttribute('href')) {
                    const id = currentFocus.getAttribute('id');
                    document.getElementById(id).click();
                } else if (currentFocus.hasAttribute('data-menu-expanded')) {
                    if (!subMenuOpened) {
                        handleSubmenuOpen(evt);
                        expandAccessibility(currentFocus);
                        getCurrentSubMenus();
                        vertPosition = 0;
                        subMenu[vertPosition].focus();
                    } else if (subMenuOpened) {
                        handleMenuClose(evt);
                        vertPosition = 0;
                        allMainMenu[horPosition].focus();
                    }
                }
                flag = true;
                break;
            case 'Escape':
            case 'Esc':
                allMainMenu[horPosition].focus();
                handleMenuClose(evt);
                flag = true;
                break;
            case 'ArrowRight':
            case 'Right':
                handleMenuClose(evt);
                if (horPosition === allMainMenu.length - 1) {
                    horPosition = 0;
                } else {
                    horPosition += horPosition === -1 ? 2 : 1;
                }

                allMainMenu[horPosition].focus();
                nextFocus = allMainMenu[horPosition];

                if (subMenuOpened) {
                    const id = nextFocus.getAttribute('id');
                    if (id !== null) {
                        const subMenuList = document.getElementById(id);
                        expandItemFor(nextFocus, subMenuList);
                        handleSubmenuOpen(null, nextFocus);
                        vertPosition = -1;
                    }
                }

                if (currentFocus.getAttribute('role') === 'submenu') {
                    const id = currentFocus.parentNode.parentNode.getAttribute('id');
                    document
                        .querySelector(`button[data-nav-list='${id}']`)
                        .setAttribute('tabindex', -1);
                } else if (currentFocus.getAttribute('class') === 'submenu-list') {
                    const id = currentFocus.getAttribute('id');
                    document
                        .querySelector(`button[data-nav-list='${id}']`)
                        .setAttribute('tabindex', -1);
                }
                currentFocus.setAttribute('tabindex', -1);

                flag = true;
                break;
            case 'ArrowLeft':
            case 'Left':
                handleMenuClose(evt);
                if (horPosition === 0 || horPosition === -1) {
                    horPosition = allMainMenu.length - 1;
                } else {
                    horPosition -= 1;
                }
                allMainMenu[horPosition].focus();
                nextFocus = allMainMenu[horPosition];

                if (subMenuOpened) {
                    const id = nextFocus.getAttribute('id');
                    if (id !== null) {
                        const subMenuList = document.getElementById(id);
                        expandItemFor(nextFocus, subMenuList);
                        handleSubmenuOpen(null, nextFocus);
                        vertPosition = -1;
                    }
                }

                if (currentFocus.getAttribute('role') === 'submenu') {
                    const id = currentFocus.parentNode.parentNode.getAttribute('id');
                    document
                        .querySelector(`button[data-nav-list='${id}']`)
                        .setAttribute('tabindex', -1);
                } else if (currentFocus.getAttribute('class') === 'submenu-list') {
                    const id = currentFocus.getAttribute('id');
                    document
                        .querySelector(`button[data-nav-list='${id}']`)
                        .setAttribute('tabindex', -1);
                }
                currentFocus.setAttribute('tabindex', -1);

                flag = true;
                break;
            case 'ArrowDown':
            case 'Down':
                if (
                    currentFocus.hasAttribute('data-menu-expanded') ||
                    currentFocus.hasAttribute('href')
                ) {
                    if (
                        hasPopup(currentFocus) &&
                        currentFocus.getAttribute('data-menu-expanded') === 'false'
                    ) {
                        expandAccessibility(currentFocus);
                        handleSubmenuOpen(evt);
                        getCurrentSubMenus();
                        vertPosition = 0;
                    } else if (vertPosition < subMenu.length - 1 && !nextFocus) {
                        vertPosition += 1;
                    } else if (subMenu.length !== 0 && !nextFocus) {
                        vertPosition = 0;
                    } else if (currentFocus.hasAttribute('tabindex') || nextFocus) {
                        if (currentFocus.getAttribute('role') !== 'menuitem') {
                            getCurrentSubMenus();
                        }
                        vertPosition = vertPosition === 0 ? 1 : 0;
                        nextFocus = null;
                    }
                }
                if (subMenu[vertPosition]) {
                    subMenu[vertPosition].focus();
                }
                flag = true;
                break;
            case 'ArrowUp':
            case 'Up':
                if (
                    currentFocus.hasAttribute('data-menu-expanded') ||
                    currentFocus.hasAttribute('href')
                ) {
                    if (hasPopup(currentFocus)) {
                        expandAccessibility(currentFocus);
                        handleSubmenuOpen(evt);
                        getCurrentSubMenus();
                        vertPosition = subMenu.length - 1;
                    } else if (vertPosition > 0 && !nextFocus) {
                        vertPosition -= 1;
                    } else if (subMenu.length !== 0 && !nextFocus) {
                        vertPosition = subMenu.length - 1;
                    } else if (currentFocus.hasAttribute('tabindex') || nextFocus) {
                        if (currentFocus.getAttribute('role') !== 'menuitem') {
                            getCurrentSubMenus();
                        }
                        vertPosition = subMenu.length - 1;
                        nextFocus = null;
                    }
                }
                if (subMenu[vertPosition]) {
                    subMenu[vertPosition].focus();
                }
                flag = true;
                break;
            case 'Home':
                goToPosition(0, evt.target, subMenuOpened);
                flag = true;
                break;
            case 'End':
                if (evt.target.hasAttribute('href')) {
                    goToPosition(subMenu.length - 1, evt.target, subMenuOpened);
                } else {
                    goToPosition(allMainMenu.length - 1, evt.target, subMenuOpened);
                }
                flag = true;
                break;
            default:
                flag = false;
                evt.stopPropagation();
                break;
        }
        if (flag) {
            evt.stopPropagation();
            evt.preventDefault();
        }
    }
});

export default eventMenuClose;
